// extracted by mini-css-extract-plugin
export default {"content":"billing_content__HW+i5","invoices":"billing_invoices__yfOPO"};